import { render, staticRenderFns } from "./HistoryBloodFat.vue?vue&type=template&id=71ade7ee&scoped=true"
import script from "./HistoryBloodFat.vue?vue&type=script&lang=js"
export * from "./HistoryBloodFat.vue?vue&type=script&lang=js"
import style0 from "./HistoryBloodFat.vue?vue&type=style&index=0&id=71ade7ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ade7ee",
  null
  
)

export default component.exports